import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Grid,
  Typography,
  Box,
} from '@mui/material';

const DermoMedicineForm = ({ medicine, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    specialite: '',
    sexe_specifique: '',
    labo: '',
    gamme: '',
    appareil: '',
    sous_appareil: '',
    composition: '',
    red_flags: '',
    effet: '',
    code_barre: '',
    quantite: '',
    forme: '',
    categorie: '',
    utilisation: '',
    frequence: '',
    association_produits: '',
    temps_application: '',
    ecran_teinte: '',
    ecran_couvrant: '',
    spf: '',
    phototype: '',
    argument_vente: '',
    age_specifique_medic: '',
    min_age_enfant: '',
    max_age_enfant: '',
    sexe_specifique_medic: '',
    femme_enceinte: '',
    allaitement: '',
    photo: '',
    peau_seche: '',
    peau_normale: '',
    peau_mixte: '',
    peau_grasse: '',
    peau_sensible_atopique: '',
    peau_tout_type: '',
    hygiene_quotidienne_et_nettoyage: '',
    ordre: '',
    demaquillant: '',
    peau_deshydratee: '',
    grain_de_peau_rugueux: '',
    exces_de_sebum: '',
    peau_terne_et_fatiguee: '',
    comedons_et_points_noirs: '',
    peau_tachetee: '',
    rides: '',
    couperosee_et_erytheme: '',
    protection_contre_pollution: '',
    protection_solaire: '',
  });

  const [photoFile, setPhotoFile] = useState(null);
  const [showFileInput, setShowFileInput] = useState(false);

  useEffect(() => {
    if (medicine) {
      setFormData(medicine);
    }
  }, [medicine]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    setPhotoFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      
      // Append all form fields
      Object.keys(formData).forEach(key => {
        if (formData[key] !== null && formData[key] !== undefined) {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Append photo if it exists
      if (photoFile) {
        formDataToSend.append('photo', photoFile);
      }

      if (medicine) {
        await axios.put(`/dermo-medicines/${medicine._id}`, formDataToSend, {
          headers: {
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem("token"),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        await axios.post('/dermo-medicines', formDataToSend, {
          headers: {
            "x-access-token": localStorage.getItem("token") || sessionStorage.getItem("token"),
            Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      onSave();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Specialite"
            name="specialite"
            value={formData.specialite}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Labo"
            name="labo"
            value={formData.labo}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Gamme"
            name="gamme"
            value={formData.gamme}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Appareil"
            name="appareil"
            value={formData.appareil}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Sous Appareil"
            name="sous_appareil"
            value={formData.sous_appareil}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Composition"
            name="composition"
            value={formData.composition}
            onChange={handleChange}
            fullWidth
            margin="normal"
            multiline
            rows={3}
          />
          <TextField
            label="Red Flags"
            name="red_flags"
            value={formData.red_flags}
            onChange={handleChange}
            fullWidth
            margin="normal"
            multiline
            rows={2}
          />
          <TextField
            label="Effet"
            name="effet"
            value={formData.effet}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Code Barre"
            name="code_barre"
            value={formData.code_barre}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Quantite"
            name="quantite"
            value={formData.quantite}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Forme"
            name="forme"
            value={formData.forme}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Categorie"
            name="categorie"
            value={formData.categorie}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Utilisation"
            name="utilisation"
            value={formData.utilisation}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Frequence"
            name="frequence"
            value={formData.frequence}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Association Produits"
            name="association_produits"
            value={formData.association_produits}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Temps Application"
            name="temps_application"
            value={formData.temps_application}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="SPF"
            name="spf"
            value={formData.spf}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Phototype"
            name="phototype"
            value={formData.phototype}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Argument Vente"
            name="argument_vente"
            value={formData.argument_vente}
            onChange={handleChange}
            fullWidth
            margin="normal"
            multiline
            rows={2}
          />
          <TextField
            label="Age Specifique Medic"
            name="age_specifique_medic"
            value={formData.age_specifique_medic}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Min Age Enfant"
            name="min_age_enfant"
            value={formData.min_age_enfant}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Max Age Enfant"
            name="max_age_enfant"
            value={formData.max_age_enfant}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </Grid>
      </Grid>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          Indications
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_seche}
                  onChange={handleChange}
                  name="peau_seche"
                />
              }
              label="Peau Seche"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_normale}
                  onChange={handleChange}
                  name="peau_normale"
                />
              }
              label="Peau Normale"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_mixte}
                  onChange={handleChange}
                  name="peau_mixte"
                />
              }
              label="Peau Mixte"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_grasse}
                  onChange={handleChange}
                  name="peau_grasse"
                />
              }
              label="Peau Grasse"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_sensible_atopique}
                  onChange={handleChange}
                  name="peau_sensible_atopique"
                />
              }
              label="Peau Sensible/Atopique"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_tout_type}
                  onChange={handleChange}
                  name="peau_tout_type"
                />
              }
              label="Peau Tout Type"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.hygiene_quotidienne_et_nettoyage}
                  onChange={handleChange}
                  name="hygiene_quotidienne_et_nettoyage"
                />
              }
              label="Hygiene Quotidienne et Nettoyage"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.demaquillant}
                  onChange={handleChange}
                  name="demaquillant"
                />
              }
              label="Demaquillant"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_deshydratee}
                  onChange={handleChange}
                  name="peau_deshydratee"
                />
              }
              label="Peau Deshydratee"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.grain_de_peau_rugueux}
                  onChange={handleChange}
                  name="grain_de_peau_rugueux"
                />
              }
              label="Grain de Peau Rugueux"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.exces_de_sebum}
                  onChange={handleChange}
                  name="exces_de_sebum"
                />
              }
              label="Exces de Sebum"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_terne_et_fatiguee}
                  onChange={handleChange}
                  name="peau_terne_et_fatiguee"
                />
              }
              label="Peau Terne et Fatiguee"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.comedons_et_points_noirs}
                  onChange={handleChange}
                  name="comedons_et_points_noirs"
                />
              }
              label="Comedons et Points Noirs"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.peau_tachetee}
                  onChange={handleChange}
                  name="peau_tachetee"
                />
              }
              label="Peau Tachetee"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.rides}
                  onChange={handleChange}
                  name="rides"
                />
              }
              label="Rides"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.couperosee_et_erytheme}
                  onChange={handleChange}
                  name="couperosee_et_erytheme"
                />
              }
              label="Couperosee et Erytheme"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.protection_contre_pollution}
                  onChange={handleChange}
                  name="protection_contre_pollution"
                />
              }
              label="Protection Contre Pollution"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.protection_solaire}
                  onChange={handleChange}
                  name="protection_solaire"
                />
              }
              label="Protection Solaire"
            />
          </Grid>
        </Grid>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          Photo
        </Typography>
        {formData.photo && !showFileInput ? (
          <Box>
            <img src={formData.photo} alt="Current Medicine" style={{ maxWidth: '100%', marginBottom: '10px' }} />
            <Button variant="outlined" onClick={() => setShowFileInput(true)}>
              Change Photo
            </Button>
          </Box>
        ) : (
          <input type="file" onChange={handleFileChange} />
        )}
      </Box>

      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </Box>
    </form>
  );
};

export default DermoMedicineForm; 